export function isFallbackImage(coverUrl) {
  return coverUrl.match(/images\/fallbacks\/[a-z]*\.svg$/)
}
